import { Reveal, Chapter } from "@/components/Reveal";

const IMAGES = [
  {
    src: "https://images.unsplash.com/photo-1601929862217-f1bf94503333?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBjYXIlMjBkYXJrJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3ODYxMzk0MzR8MA&ixlib=rb-4.1.0&q=85&w=800",
    caption: "Luxury Cars",
    aspect: "aspect-[4/5]",
    slug: "luxury",
  },
  {
    src: "https://images.pexels.com/photos/8985461/pexels-photo-8985461.jpeg?auto=compress&cs=tinysrgb&w=800",
    caption: "Inspection Photos",
    aspect: "aspect-[4/3]",
    slug: "inspection",
  },
  {
    src: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?auto=format&fit=crop&w=800&q=80",
    caption: "Engine Bay",
    aspect: "aspect-square",
    slug: "engine-bay",
  },
  {
    src: "https://images.unsplash.com/photo-1727893380169-4dda123e19f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxjYXIlMjBkaWFnbm9zdGljJTIwb2JkJTIwc2Nhbm5lcnxlbnwwfHx8fDE3ODYxMzk0MzR8MA&ixlib=rb-4.1.0&q=85&w=800",
    caption: "OBD Scanner",
    aspect: "aspect-[4/3]",
    slug: "obd",
  },
  {
    src: "https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?auto=format&fit=crop&w=800&q=80",
    caption: "SUVs",
    aspect: "aspect-[4/5]",
    slug: "suv",
  },
  {
    src: "https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxjYXIlMjBlbmdpbmUlMjBpbnNwZWN0aW9uJTIwbWVjaGFuaWN8ZW58MHx8fHwxNzg2MTM5NDM0fDA&ixlib=rb-4.1.0&q=85&w=800",
    caption: "Paint & Body Check",
    aspect: "aspect-[4/3]",
    slug: "paint",
  },
  {
    src: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?auto=format&fit=crop&w=800&q=80",
    caption: "Road Test",
    aspect: "aspect-[4/5]",
    slug: "road-test",
  },
  {
    src: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=800&q=80",
    caption: "Customer Delivery",
    aspect: "aspect-[4/3]",
    slug: "delivery",
  },
];

export const Gallery = () => (
  <section
    id="gallery"
    data-testid="gallery-section"
    className="border-y border-white/10 bg-[#0a0a0a] py-28 md:py-36"
  >
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <Reveal>
        <Chapter index="07" label="Gallery" />
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-8 max-w-3xl font-heading text-4xl font-extrabold tracking-tight text-white md:text-6xl">
          On the ground,
          <span className="block text-white/40">under the hood.</span>
        </h2>
      </Reveal>

      <div className="mt-16 columns-1 gap-5 sm:columns-2 lg:columns-3">
        {IMAGES.map((img, i) => (
          <Reveal key={img.slug} delay={0.04 * (i % 3)} className="mb-5 break-inside-avoid">
            <figure
              data-testid={`gallery-item-${img.slug}`}
              className="group relative overflow-hidden rounded-2xl border border-white/10"
            >
              <img
                src={img.src}
                alt={img.caption}
                loading="lazy"
                className={`${img.aspect} w-full object-cover transition-transform duration-700 group-hover:scale-110`}
              />
              <figcaption className="gallery-caption pointer-events-none absolute inset-x-0 bottom-0 translate-y-3 p-5 opacity-0 transition-[opacity,transform] duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                <span className="font-heading text-sm font-extrabold uppercase tracking-[0.18em] text-white">
                  {img.caption}
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
